window.productFormState = {
    requiredSelections: {
        size: false,
        color: false,
        colors: false,
        artwork: {}
    },
    variant: {
        available: true,  // Default to true until we know otherwise
        selected: false   // Track if a valid variant has been fully selected
    },
    orderSearchInProgress: false, // New flag to track API search state
    artworkNotFound: false,      // Flag for artwork not found state
    artworkNotApproved: false,   // Flag for artwork not approved state
    checkButtonState: function(form) {
        const addToCartBtn = form.querySelector('.btn-atc');
        const artworkIdInput = form.querySelector('#product-form-input-order-no');
        // Support both size/sizes and color/colors
        const sizeInputExists = form.querySelector('input[name="size"]') || form.querySelector('input[name="sizes"]');
        const sizeChecked = form.querySelector('input[name="size"]:checked') || form.querySelector('input[name="sizes"]:checked');
        const colorInputExists = form.querySelector('input[name="color"]') || form.querySelector('input[name="colors"]');
        const colorChecked = form.querySelector('input[name="color"]:checked') || form.querySelector('input[name="colors"]:checked');
        // If no size input exists, treat as true (not required)
        const hasSize = sizeInputExists ? !!sizeChecked : true;
        // If no color input exists, treat as true (not required)
        const hasColor = colorInputExists ? !!colorChecked : true;
        const artworkFields = Object.keys(this.requiredSelections.artwork);
        const allArtworkSelected = artworkFields.length === 0 || 
            artworkFields.every(field => this.requiredSelections.artwork[field]);
        
        // Check what options are needed
        const sizeInput = form.querySelector('input[name="size"]');
        const colorInput = form.querySelector('input[name="color"]');
        const colorsInput = form.querySelector('input[name="colors"]');

        const needsSize = sizeInput !== null;
        const needsColor = colorInput !== null || colorsInput !== null; // Check for both color and colors
        
        // Check for order/email input
        const orderInput = form.querySelector('#product-form-input-order-no');
        const needsOrderInput = orderInput !== null;
        const hasOrderInput = needsOrderInput && orderInput.value.trim() !== '';
        
        // If an API search is in progress, ALWAYS keep the button disabled
        if (this.orderSearchInProgress) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = window.product_form_t ? window.product_form_t.searchingForArtwork : 'Searching for artwork...';
            return;
        }
        
        // Check for specific artwork error states FIRST
        if (this.artworkNotFound) {
            addToCartBtn.disabled = true;
            // Text is already set in initProductFormApi
            return;
        }
        if (this.artworkNotApproved) {
            addToCartBtn.disabled = true;
            // Text is already set in initProductFormApi
            return;
        }
        
        // Messaging logic - order matters here!
        
        // 1. First check for missing size/color selections
        if (!hasColor && !hasSize) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = window.product_form_t ? window.product_form_t.selectSizeAndColor : 'Please select size and color';
            if (artworkIdInput && !artworkIdInput.value) {
                artworkIdInput.disabled = true;
            }
            return;
        }

        // Only show size message if size input exists
        if (sizeInputExists && !hasSize) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = window.product_form_t ? window.product_form_t.selectSize : 'Please select size';
            if (artworkIdInput && !artworkIdInput.value) {
                artworkIdInput.disabled = true;
            }
            return;
        }
        
        // Only show color message if color input exists
        if (colorInputExists && !hasColor) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = window.product_form_t ? window.product_form_t.selectColor : 'Please select color';
            if (artworkIdInput && !artworkIdInput.value) {
                artworkIdInput.disabled = true;
            }
            return;
        }
        
        // 2. Check for order/email input if needed
        if (needsOrderInput && !hasOrderInput) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = window.product_form_t ? window.product_form_t.enterOrderOrEmail : 'Please enter order number or email';
            if (artworkIdInput && !artworkIdInput.value) {
                artworkIdInput.disabled = false;
            }
            return;
        }
        
        // 3. Check for variant availability only if a full valid variant selection has been made
        if (this.variant.selected && !this.variant.available) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = addToCartBtn.dataset.textSoldOut;
            return;
        }
        
        // 4. Then check for missing artwork
        if (!allArtworkSelected) {
            // Find first unselected artwork
            const missingArtwork = artworkFields.find(field => !this.requiredSelections.artwork[field]);
            if (missingArtwork) {
                const artworkText = missingArtwork.replace('select-', '').replace(/-/g, ' ');
                addToCartBtn.disabled = true;
                addToCartBtn.textContent = `Select ${artworkText}`;
                return;
            }
        }
        
        // 5. All requirements met
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = addToCartBtn.dataset.textAddToCart;
    }
};

window.initProductFormApi = async (searchTerm, currentItem) => {
    const productContainer = document.querySelector('.product-container');
    if (!productContainer && !currentItem) {
        return;
    }
    const artworkOptions = document.querySelectorAll('.artwork-option');
    const card = currentItem ? currentItem.querySelector('#artwork-details-card') : productContainer.querySelector('#artwork-details-card');
    if (!card) {
        return;
    }
    const input = currentItem ? currentItem.querySelector('#product-form-input-order-no') : productContainer.querySelector('#product-form-input-order-no');
    const loading = currentItem ? currentItem.querySelector('#artwork-details-card-loading') : productContainer.querySelector('#artwork-details-card-loading');
    const options = currentItem ? currentItem.querySelector('#artwork-details-card-options') : productContainer.querySelector('#artwork-details-card-options');
    const notApprovedEl = currentItem ? currentItem.querySelector('#artwork-details-card-not-approved') : productContainer.querySelector('#artwork-details-card-not-approved');
    const atcBtn = currentItem ? currentItem.querySelector('button.btn-atc') : productContainer.querySelector('button.btn-atc');
    const { customerEmail } = card.dataset;
    const disableLeaveBlankInArtwork = card.dataset.disableLeaveBlankInArtwork === 'true';
    let searchData;

    // Mark search as starting
    if (window.productFormState) {
        window.productFormState.orderSearchInProgress = true;
        window.productFormState.artworkNotFound = false;
        window.productFormState.artworkNotApproved = false;
        
        // Always immediately disable the button when a search starts
        const form = input ? input.closest('form') : null;
        if (form) window.productFormState.checkButtonState(form);
    }

    atcBtn.disabled = true;

    if (!card || !input) {
        // Reset search state and return
        if (window.productFormState) {
            window.productFormState.orderSearchInProgress = false;
            window.productFormState.artworkNotFound = false;
            window.productFormState.artworkNotApproved = false;
        }
        return;
    }

    if (!searchTerm) {
        // Check if elements exist before trying to access them
        const notAvailableEl = document.querySelector('#artwork-details-card-not-available');
        if (notAvailableEl) {
            notAvailableEl.style.display = 'none';
        }
        
        if (notApprovedEl) {
            notApprovedEl.style.display = 'none';
        }
        
        if (options) {
            options.style.display = 'none';
            card.style.display = 'none';
            loading.style.display = 'none';
            options.classList.remove('artwork-details-card-options--loaded');
            options.querySelectorAll('.artwork-swatches > li').forEach((el) => el.remove());
        }
        
        if (card) {
            card.querySelectorAll('.alert').forEach((el) => el.remove());
        }

        // Reset search state when there's no search term
        if (window.productFormState) {
            window.productFormState.orderSearchInProgress = false;
            window.productFormState.artworkNotFound = false;
            window.productFormState.artworkNotApproved = false;
            // Optionally call checkButtonState if needed when cleared
            const form = input ? input.closest('form') : null;
            if(form) window.productFormState.checkButtonState(form); 
        }
        return;
    }

    if (searchTerm) {
        searchData = searchTerm;
    } else if (customerEmail) {
        searchData = customerEmail;
    }  else if (window.localStorage.getItem('artwork-order-id')) {
        input.value = window.localStorage.getItem('artwork-order-id')
        searchData = input.value
    }

    if (!searchData) {
        // Reset search state when there's no search data
        if (window.productFormState) {
            window.productFormState.orderSearchInProgress = false;
            window.productFormState.artworkNotFound = false;
            window.productFormState.artworkNotApproved = false;
        }
        return;
    }

    // Check if artwork-swatches elements exist
    const artworkSwatches = options ? options.querySelectorAll('.artwork-swatches') : null;
    if (!artworkSwatches || artworkSwatches.length === 0) {
        // Reset search state when there are no artwork swatches
        if (window.productFormState) {
            window.productFormState.orderSearchInProgress = false;
            // Consider if flags should be reset here too, maybe not if artwork is needed
        }
        return;
    }

    const form = document.querySelector('form[action="/cart/add"]');
    
    if (form) {
        window.productFormState.checkButtonState(form);
    }

    document.querySelector('#artwork-details-card-not-available').style.display = 'none';
    notApprovedEl.style.display = 'none';
    options.style.display = 'none';
    card.style.display = 'block';
    loading.style.display = 'block';
    options.classList.remove('artwork-details-card-options--loaded');
    
    options.querySelectorAll('.artwork-swatches > li').forEach((el) => el.remove());
    card.querySelectorAll('.alert').forEach((el) => el.remove());

    try {
        const response = await fetch(`https://oms.thecustomcaptain.com/search?query=${searchData}`);
        const data = await response.json();

        const sizeInputs = document.querySelectorAll(".product-option[name='size'");
        let isSizeSelected = false;
        const translations = window.product_form_t;

        sizeInputs && sizeInputs.forEach((input) => {
            if (input.checked) {
                isSizeSelected = true;
            }
        });

        // Filter out any cancelled artworks
        const validArtworks = data.filter(artwork => artwork.artwork_status !== "cancelled");
        const warningMessage = document.querySelector('.product__warning');

        // Check if any valid artwork exists
        if (validArtworks.length === 0) {
            document.querySelector('#artwork-details-card-not-available').style.display = 'block';
            window.localStorage.setItem('artwork-order-id-error', 'error');
            loading.style.display = 'none';
            notApprovedEl.style.display = 'none';
            atcBtn.disabled = true;
            atcBtn.textContent = atcBtn.classList.contains('btn-atc--art-work') ?  'Add' : 'No artwork available!'
            
            // Reset artwork selections when no artwork is found
            if (window.productFormState) {
                window.productFormState.requiredSelections.artwork = {};
                window.productFormState.orderSearchInProgress = false;
                window.productFormState.artworkNotFound = true;
                window.productFormState.artworkNotApproved = false;
                window.productFormState.checkButtonState(form);
            }

            if (warningMessage) {
                warningMessage.classList.add('hidden');
            }
        } else {
            document.querySelector('#artwork-details-card-not-available').style.display = 'none';

            // Check if any artwork is approved/complete
            const approvedArtworks = validArtworks.filter(artwork => artwork.artwork_status === "complete");
            const hasApprovedArtwork = approvedArtworks.length > 0;

            if (!hasApprovedArtwork) {
                // All artworks are not approved
                loading.style.display = 'none';
                options.style.display = 'none';
                notApprovedEl.style.display = 'block';
                
                // Try to find the UUID of the first non-approved artwork for the link
                const firstUnapprovedArtwork = validArtworks[0];
                if (firstUnapprovedArtwork && firstUnapprovedArtwork.uuid) {
                    notApprovedEl.innerHTML = notApprovedEl.innerHTML.replace('{{id}}', firstUnapprovedArtwork.uuid);
                }
                
                // Set button text and keep it disabled when artwork is not approved
                atcBtn.disabled = true;
                atcBtn.textContent = window.product_form_t ? window.product_form_t.artworkNotApproved : 'Artwork is not approved';
                
                // Reset artwork selections when artwork is not approved
                if (window.productFormState) {
                    window.productFormState.requiredSelections.artwork = {};
                    window.productFormState.orderSearchInProgress = false;
                    window.productFormState.artworkNotFound = false;
                    window.productFormState.artworkNotApproved = true;
                    window.productFormState.checkButtonState(form);
                }
            } else {
                // At least one artwork is approved
                loading.style.display = 'none';
                notApprovedEl.style.display = 'none';
                options.style.display = 'block';
                
                // Make sure to hide the "not available" message when we have approved artwork
                const notAvailableEl = document.querySelector('#artwork-details-card-not-available');
                if (notAvailableEl) {
                    notAvailableEl.style.display = 'none';
                }
                
                options.querySelectorAll('.artwork-swatches').forEach((el) => {
                    let artworkList = '';
                    const productOptions = document.querySelector('#product-options');
                    let firstOption = productOptions && productOptions.querySelector('.h6') ? 
                        productOptions.querySelector('.h6').textContent.trim() : '';
                    atcBtn.disabled = true;
                    atcBtn.textContent = atcBtn.classList.contains('btn-atc--art-work') ?  translations.add : translations.addToCart;
                    isSizeSelected ? atcBtn.disabled = false : atcBtn.disabled = true;
                    if (firstOption === 'Size') {
                        isSizeSelected ? atcBtn.textContent = atcBtn.classList.contains('btn-atc--art-work') ?  translations.add : translations.addToCart : atcBtn.textContent = atcBtn.classList.contains('btn-atc--art-work') ?  translations.add : translations.selectSize
                    } else if (firstOption === 'Color') {
                        isSizeSelected ? atcBtn.textContent = atcBtn.classList.contains('btn-atc--art-work') ?  translations.add : translations.addToCart : atcBtn.textContent = atcBtn.classList.contains('btn-atc--art-work') ?  translations.add : translations.selectColor
                    } else {
                        isSizeSelected ? atcBtn.textContent = atcBtn.classList.contains('btn-atc--art-work') ?  translations.add : translations.addToCart : atcBtn.textContent = atcBtn.classList.contains('btn-atc--art-work') ?  translations.add : translations.selectOption
                    }
                    window.localStorage.setItem('artwork-order-id-error', 'success')
                    
                    // Use only approved artworks for the artwork list
                    approvedArtworks.forEach((artwork) => {
                        if(artwork.png){
                        artwork.png.forEach((png, index) => {
                            let value = png.url;

                            if (window.front_colors_images && window.back_colors_images) {
                                observeCurrentColor((color) => {
                                    if (el.dataset.option === 'select-front') {
                                        document.querySelectorAll('[name="properties[select-front]"]').forEach((input) => {
                                            input.value = window.front_colors_images[color];
                                        });
                                        value = window.front_colors_images[color];
                                    } else if (el.dataset.option === 'select-back') {
                                        document.querySelectorAll('[name="properties[select-back]"]').forEach((input) => {
                                            input.value = window.back_colors_images[color];
                                        });
                                        value = window.back_colors_images[color];
                                    }
                                });
                            }

                            if (png.thumbnails) {
                                artworkList += `
                                    <li class="col p-1">
                                        <input 
                                            class="artwork-option visually-hidden ${currentItem ? 'artwork-option--cart-upsell': null}"
                                            type="radio" 
                                            name="properties[${el.dataset.option}]"
                                            id="input-${el.dataset.option}-${artwork.art_id}-${index}" 
                                            value="${value}"
                                            data-png="${png.thumbnails.large.url}"
                                            required>
                                        <label
                                            for="input-${el.dataset.option}-${artwork.art_id}-${index}" 
                                            aria-label="${artwork.art_id}-${index}"
                                            class="text-center"
                                            style="cursor: pointer">
                                            <img 
                                                src="${png.thumbnails.large.url}" 
                                                alt="" 
                                                width="${png.thumbnails.large.width}" 
                                                height="${png.thumbnails.large.height}" 
                                                class="img-thumbnail mb-1" 
                                                loading="lazy">
                                            <small class="text-muted" style="font-size: .875em;">
                                                ${artwork.art_id}
                                            </small>
                                        </label>
                                    </li>
                                `;
                            } else {
                                artworkList += `
                                    <li class="col p-1">
                                        <input 
                                            class="artwork-option visually-hidden" 
                                            type="radio" 
                                            name="properties[${el.dataset.option}]" 
                                            id="input-${el.dataset.option}-${artwork.art_id}-${index}" 
                                            value="${value}"
                                            data-png="${png.url}"
                                            required>
                                        <label
                                            for="input-${el.dataset.option}-${artwork.art_id}-${index}" 
                                            aria-label="${artwork.art_id}-${index}"
                                            class="text-center"
                                            style="cursor: pointer">
                                            <img 
                                                src="${png.url}" 
                                                alt="" 
                                                width="" 
                                                height="" 
                                                class="img-thumbnail mb-1" 
                                                loading="lazy">
                                            <small class="text-muted" style="font-size: .875em;">
                                                ${artwork.art_id}
                                            </small>
                                        </label>
                                    </li>
                                `;
                            }
                        });
                        }
                    });
        
                    el.insertAdjacentHTML('afterbegin', artworkList);
        
                    if (
                        !disableLeaveBlankInArtwork &&
                        (el.dataset.option === 'select-front' || el.dataset.option === 'select-back')
                    ) {
                        el.insertAdjacentHTML('beforeEnd', `
                            <li class="col p-1">
                                <input 
                                    class="artwork-option visually-hidden" 
                                    type="radio" 
                                    name="properties[${el.dataset.option}]" 
                                    id="input-${el.dataset.option}-blank" 
                                    value="blank"
                                    required>
                                <label
                                    for="input-${el.dataset.option}-blank" 
                                    aria-label=""
                                    class="text-center"
                                    style="cursor: pointer">
                                    <img 
src="data:image/png;base64,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"                                         alt="" 
                                        width="" 
                                        height="" 
                                        class="img-thumbnail mb-1" 
                                        loading="lazy">
                                </label>
                            </li>
                        `);
                    }

                    el.querySelectorAll('input[type="radio"]').forEach((input) => {
                        input.addEventListener('change', () => {
                            const form = input.closest('form');
                            const addToCartBtn = form.querySelector('.btn-atc');
                            const variantSelect = form.querySelector('select[name="id"]');
                            const selectedVariant = JSON.parse(form.dataset.variants).find(
                                variant => variant.id === Number(variantSelect.value)
                            );
                            
                            // Update our central state with the artwork selection
                            const artworkType = input.name.match(/properties\[(.*?)\]/)[1];
                            window.productFormState.requiredSelections.artwork[artworkType] = true;
                            
                            // Update variant availability in our central state
                            window.productFormState.variant.available = selectedVariant ? selectedVariant.available : false;
                            
                            // Check and update button state
                            window.productFormState.checkButtonState(form);
                        });
                    });

                    setTimeout(() => {
                        loading.style.display = 'none';
                        options.classList.add('artwork-details-card-options--loaded');
                        options.style.height = null;
                        options.style.opacity = null;

                        // Initialize the artwork requirements
                        const form = options.closest('form');
                        const artworkSelectors = form.querySelectorAll('.artwork-swatches');
                        
                        artworkSelectors.forEach(selector => {
                            const artworkType = selector.dataset.option;
                            // Check if an option is already selected
                            const selectedArtwork = form.querySelector(`input[name="properties[${artworkType}]"]:checked`);
                            window.productFormState.requiredSelections.artwork[artworkType] = !!selectedArtwork;
                        });
                        
                        // SIMPLE FIX: Make sure to keep the button disabled
                        const atcBtn = form.querySelector('.btn-atc');
                        if (atcBtn) {
                            atcBtn.disabled = true;
                            atcBtn.textContent = 'Select artwork';
                        }
                        
                        // Initialize with size/color state too
                        const sizeInput = form.querySelector('input[name="size"]:checked');
                        const colorInput = form.querySelector('input[name="color"]:checked');
                        const colorsInput = form.querySelector('input[name="colors"]:checked');
                        const needsSize = form.querySelector('input[name="size"]') !== null;
                        const needsColor = form.querySelector('input[name="color"]') !== null || form.querySelector('input[name="colors"]') !== null;
                        
                        window.productFormState.requiredSelections.size = needsSize ? !!sizeInput : true;
                        window.productFormState.requiredSelections.color = needsColor ? (!!colorInput || !!colorsInput) : true;
                        window.productFormState.requiredSelections.colors = needsColor && form.querySelector('input[name="colors"]') ? !!colorsInput : true;
                        
                        // Get initial variant
                        const variantSelect = form.querySelector('select[name="id"]');
                        if (variantSelect) {
                            const selectedOptions = [];
                            form.querySelectorAll(".product-option").forEach((optionEl) => {
                                if (optionEl.type === "radio") {
                                    if (optionEl.checked) {
                                        selectedOptions.push(optionEl.value);
                                    }
                                } else if (optionEl.type === "select-one") {
                                    selectedOptions.push(optionEl.value);
                                }
                            });
                            
                            const selectedVariant = JSON.parse(form.dataset.variants).find(
                                variant => variant.id === Number(variantSelect.value)
                            );
                            
                            window.productFormState.variant.available = selectedVariant ? selectedVariant.available : false;
                            window.productFormState.variant.selected = !!selectedVariant && selectedOptions.length > 0;
                        }
                        
                        // Initial button check
                        window.productFormState.checkButtonState(form);

                        // --- FIX: Update artwork swatch value on color change ---
                        // Listen for color changes and update artwork swatch values accordingly
                        const colorInputs = form.querySelectorAll('input[name="color"]');
                        if (colorInputs.length && (window.front_colors_images || window.back_colors_images)) {
                            colorInputs.forEach(input => {
                                input.addEventListener('change', () => {
                                    const selectedColor = form.querySelector('input[name="color"]:checked')?.value;
                                    if (!selectedColor) return;

                                    // Update select-front
                                    const frontArtworkInput = form.querySelector('input[name="properties[select-front]"]:checked');
                                    if (frontArtworkInput && window.front_colors_images) {
                                        frontArtworkInput.value = window.front_colors_images[selectedColor];
                                    }
                                    // Update select-back
                                    const backArtworkInput = form.querySelector('input[name="properties[select-back]"]:checked');
                                    if (backArtworkInput && window.back_colors_images) {
                                        backArtworkInput.value = window.back_colors_images[selectedColor];
                                    }
                                });
                            });
                        }
                        // --- END FIX ---
                    }, 1000);
                });
            }

            if (warningMessage) {
                warningMessage.classList.remove('hidden');
            }
        }
    } catch (error) {
        console.error('Error fetching artwork:', error);
        
        // Make sure these elements exist before trying to access them
        if (document.querySelector('#artwork-details-card-not-available')) {
            document.querySelector('#artwork-details-card-not-available').style.display = 'block';
        }
        
        if (loading) {
            loading.style.display = 'none';
        }
        
        if (atcBtn) {
            atcBtn.disabled = true;
            atcBtn.textContent = window.product_form_t ? window.product_form_t.artworkSearchError : 'Error searching artwork';
        }

        // Set error state flags
        if (window.productFormState) {
            window.productFormState.artworkNotFound = true;
            window.productFormState.artworkNotApproved = false;
        }
    } finally {
        // Always reset the search state when the API call is complete
        if (window.productFormState) {
            window.productFormState.orderSearchInProgress = false;
            
            // Re-check button state based on search results
            const form = input ? input.closest('form') : null;
            if (form) window.productFormState.checkButtonState(form);
        }
    }
    
    document.querySelectorAll('.artwork-swatches input:not(.artwork-option--cart-upsell)').forEach((el) => {
        el.addEventListener('click', () => {
            const productCarouselEl = el.closest('.product-container')?.querySelector('.product-carousel');
            if (!productCarouselEl) return;
            
            const bsCarousel = bootstrap.Carousel.getInstance(productCarouselEl);
            if (!bsCarousel) return;
            
            const { option } = el.closest('[data-option]').dataset;
            const mockupOption = productCarouselEl.querySelector(`[data-mockup="${option}"]`);
            const mockupCustom = productCarouselEl.querySelector(`[data-mockup-custom]`);
            const carouselItem = mockupOption ? mockupOption : mockupCustom;
            if (!carouselItem) return;
            
            const index = Number(carouselItem.dataset.index);
            bsCarousel.to(index);

            const imgContainer = carouselItem.querySelector('.artwork-img-container');
            if (imgContainer) {
                imgContainer.innerHTML = `
                    <img src="${el.dataset.png}" class="img-fluid" width="" height="" alt="" />
                `;
            }
        });
    });

    document.addEventListener('click', (e) => {
        if(e.target.closest('.artwork-swatches li')) {
            setTimeout(() => {
                const checkedBlankInput = document.querySelector('.artwork-swatches input[value="blank"]:checked');
                if (checkedBlankInput) {
                    const uncheckedBlankInput = document.querySelector('.artwork-swatches input[value="blank"]:not(:checked)');
                    if (uncheckedBlankInput) {
                        uncheckedBlankInput.closest('li')?.classList.add('disable');
                    }
                } else {
                    document.querySelectorAll('.artwork-swatches input[value="blank"]').forEach(item => {
                        item.closest('li')?.classList.remove('disable');
                    });
                }
            }, 0);
        }
    });
};
window.initProductFormApi();

document.addEventListener('DOMContentLoaded', function() {
    const orderInput = document.querySelector('#product-form-input-order-no');
    if (orderInput) {
        if (!orderInput.value) {
            const storedArtworkId = window.localStorage.getItem('artwork-order-id');
            if (storedArtworkId) {
                orderInput.value = storedArtworkId;
                if (orderInput.disabled) {
                    orderInput.disabled = false;
                }
            }
        }
        const form = orderInput.closest('form');
        if (form && window.productFormState) {
            window.productFormState.checkButtonState(form);
        }
        if (orderInput.value) {
            window.initProductFormApi(orderInput.value);
        }
    }
});

const urlParams = new URLSearchParams(window.location.search);
const id = urlParams.get('id');
const input = document.querySelector('#product-form-input-order-no');

if (id) {
    input.value = id.toString();
    window.initProductFormApi(id);
}

const setDisableStateSubmitButton = (e) => {
    const form = e.currentTarget.closest('form');
    const submitButton = form.querySelector('.btn-atc');

    const artworkIdInput = form.querySelector('#product-form-input-order-no');

    submitButton.disabled = true;
    submitButton.textContent = window.product_form_t ? window.product_form_t.enterOrderOrEmail : 'Please enter order number or email';

    // When typing in the order field, reset artwork selections
    if (window.productFormState) {
        window.productFormState.requiredSelections.artwork = {};
        window.productFormState.orderSearchInProgress = true;
    }
};

document.querySelector('#product-form-input-order-no')?.addEventListener('input', setDisableStateSubmitButton);
document.querySelector('#product-form-input-order-no')?.addEventListener('input', window.debounce((e) => {
    const term = e.target.value;
    const form = e.target.closest('form');

    if (e.target.value.length > 0) {
        if (window.productFormState) {
            window.productFormState.orderSearchInProgress = true;
            window.productFormState.checkButtonState(form);
        }
        
        window.initProductFormApi(term);
        window.localStorage.setItem('artwork-order-id', term);
    } else {
        window.initProductFormApi();
        window.localStorage.removeItem('artwork-order-id');
        
        if (window.productFormState) {
            window.productFormState.orderSearchInProgress = false;
            window.productFormState.checkButtonState(form);
        }
    }
}, 500));


window.initArtWorkLister = () => {
    const artworkInput = document.querySelectorAll('.cart-upsell__artwork-input');

    artworkInput.forEach((input) => {
        input.addEventListener('input', setDisableStateSubmitButton);
        input.addEventListener('input', window.debounce((e) => {
            const term = e.target.value;
            const currentItem = e.target.closest('.carousel-item');

            if (e.target.value.length > 0) {
                window.initProductFormApi(term, currentItem);
            }
        }, 500));
    });
};

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.product-option').forEach((optionEl) => {
        optionEl.addEventListener("change", () => {
            const form = optionEl.closest('form[action="/cart/add"]');
            if (!form) return;
            
            if (optionEl.name === 'size' || optionEl.name === 'sizes') {
                window.productFormState.requiredSelections.size = optionEl.checked;
            }
            if (optionEl.name === 'color' || optionEl.name === 'colors') {
                window.productFormState.requiredSelections.color = optionEl.checked;
            }
            
            const selectedOptions = [];
            form.querySelectorAll(".product-option").forEach((optionEl2) => {
                if (optionEl2.type === "radio") {
                    if (optionEl2.checked) {
                        selectedOptions.push(optionEl2.value);
                    }
                } else if (optionEl2.type === "select-one") {
                    selectedOptions.push(optionEl2.value);
                }
            });
            
            const selectedVariant = JSON.parse(form.dataset.variants).find(
                (variant) => JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
            );
            
            window.productFormState.variant.available = selectedVariant ? selectedVariant.available : false;
            window.productFormState.variant.selected = !!selectedVariant && selectedOptions.length > 0;
            
            window.productFormState.checkButtonState(form);
        });
    });
});

document.addEventListener('click', (e) => {
    if (e.target.closest('.artwork-swatches li')) {
        setTimeout(() => {
            const inputEl = e.target.closest('li').querySelector('input[type="radio"]');
            if (!inputEl) return;
            
            const form = inputEl.closest('form');
            if (!form) return;
            
            if (window.productFormState && inputEl.checked) {
                const artworkType = inputEl.name.match(/properties\[(.*?)\]/)[1];
                window.productFormState.requiredSelections.artwork[artworkType] = true;
                
                const variantSelect = form.querySelector('select[name="id"]');
                if (variantSelect) {
                    const selectedVariant = JSON.parse(form.dataset.variants).find(
                        variant => variant.id === Number(variantSelect.value)
                    );
                    
                    window.productFormState.variant.available = selectedVariant ? selectedVariant.available : false;
                    window.productFormState.variant.selected = !!selectedVariant;
                    
                    const sizeInput = form.querySelector('input[name="size"]:checked');
                    const colorInput = form.querySelector('input[name="color"]:checked');
                    const colorsInput = form.querySelector('input[name="colors"]:checked');
                    const needsSize = form.querySelector('input[name="size"]') !== null;
                    const needsColor = form.querySelector('input[name="color"]') !== null || form.querySelector('input[name="colors"]') !== null;
                    
                    window.productFormState.requiredSelections.size = needsSize ? !!sizeInput : true;
                    window.productFormState.requiredSelections.color = needsColor ? (!!colorInput || !!colorsInput) : true;
                    window.productFormState.requiredSelections.colors = needsColor && form.querySelector('input[name="colors"]') ? !!colorsInput : true;
                }
                
                // Check button state
                window.productFormState.checkButtonState(form);
            }
        }, 0);
    }
});

const observeCurrentColor = (callback) => {
    const colorInputs = document.querySelectorAll('input[name="color"]');
    if (!colorInputs) return;

    colorInputs.forEach((input) => {
        if (input.checked) {
            callback(input.value);
        };

        input.addEventListener('change', () => {
            if (input.checked) {
                callback(input.value);
            }
        });
    });
};

// Defensive check: always disable ATC if no color is selected
function enforceColorSelection(form) {
  const colorInputExists = form.querySelector('input[name="color"]') || form.querySelector('input[name="colors"]');
  if (!colorInputExists) return; // No color option, do nothing!
  const colorChecked = form.querySelector('input[name="color"]:checked') || form.querySelector('input[name="colors"]:checked');
  const atcBtn = form.querySelector('.btn-atc');
  if (atcBtn && !colorChecked) {
    atcBtn.disabled = true;
    atcBtn.textContent = atcBtn.dataset.textSelectColor || "Please select color";
  }
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    enforceColorSelection(form);
    form.querySelectorAll('.product-option').forEach(optionEl => {
      optionEl.addEventListener('change', () => enforceColorSelection(form));
    });
  });
});